// import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class VehicleTempSensorStore {
  loading = false;
  total = 0;
  tempSensorVehicles = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      tempSensorVehicles: observable,
      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, searchField }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      searchField: searchField,
    };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=vehicleSensor", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/vehicle/vehicleSensor", {
        params: postData,
      });
    this.tempSensorVehicles = response?.data?.VehicleSensorData;
    this.total = parseInt(response?.data?.TotalCount);

    this.loading = false;
  }
}

export default VehicleTempSensorStore;
